import {
  AccountCancellationPolicyDto,
  AccountCancellationPolicyResponseDto,
  ResetCancellationPolicyTypesResponseDto,
} from '../core/cancellation-policy';
import { HttpClient } from './http';

export interface CancellationPolicyService {
  get: () => Promise<AccountCancellationPolicyResponseDto>;
  update: (
    dto: AccountCancellationPolicyDto,
  ) => Promise<AccountCancellationPolicyResponseDto>;
  resetTypes: () => Promise<ResetCancellationPolicyTypesResponseDto>;
}

export function createCancellationPolicyService(
  httpClient: HttpClient,
  baseUrl: string,
): CancellationPolicyService {
  return {
    get: () =>
      httpClient<AccountCancellationPolicyResponseDto>(
        `${baseUrl}/cancellation-policy`,
        'get',
      ),

    update: (dto) =>
      httpClient<AccountCancellationPolicyResponseDto>(
        `${baseUrl}/cancellation-policy`,
        'put',
        { body: dto },
      ),

    resetTypes: () =>
      httpClient<ResetCancellationPolicyTypesResponseDto>(
        `${baseUrl}/cancellation-policy/reset-types`,
        'post',
      ),
  };
}
